import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entity: {},
    hasMoreDataToLoad: true
};

const requestActivities = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveActivities = (state, action) => {
    if (Object.keys(state.entity).length !== 0 && !action.data.refresh) {
        return {
            ...state,
            isFetching: false,
            entity: {
                ...action.data,
                activityList: [...state.entity.activityList, ...action.data.activityList]
            },
            lastUpdated: action.receivedAt,
            hasMoreDataToLoad: action.data.activityList && action.data.activityList.length === 10
        };
    }
    return {
        ...state,
        isFetching: false,
        entity: action.data,
        lastUpdated: action.receivedAt,
        hasMoreDataToLoad: action.data.activityList && action.data.activityList.length === 10
    };
};

const removeProfilePageActivitiesProfileImage = (state, action) => {
    let newEntity = {
        ...state.entity
    };
    let updated = false;
    if (newEntity.activityList) {
        newEntity.activityList.forEach((item) => {
            if (item.ownerDisplayName !== action.displayName) {
                return;
            }
            item.ownerProfileImageUrlLarge = null;
            item.ownerProfileImageUrlMedium = null;
            item.ownerProfileImageUrlSmall = null;
            updated = true;
        });
    }

    if (!updated) {
        return state;
    }

    return {
        ...state,
        entity: newEntity
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    [types.REQUEST_ACTIVITIES]: requestActivities,
    [types.RECEIVE_ACTIVITIES]: receiveActivities,
    [types.RESET_ACTIVITIES]: resetToInitialState,
    [types.REMOVE_PROFILE_PAGE_ACTIVITIES_PROFILE_IMAGE]: removeProfilePageActivitiesProfileImage
};

export const getActivities = (state) => {
    return state.activityList;
};

export default function activityList(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
